var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pb-0 px-0",attrs:{"id":"home","fluid":"","tag":"section"}},[_c('headline'),_c('gallery-home')],1)}
var staticRenderFns = []

export { render, staticRenderFns }